import {
  IWorkingDaysAnalyticsActivityEnum,
  IWorkingDaysAnalyticsActivityV2Enum,
} from 'lib/enum/working-days-analytics-activity.enum';

export interface CumulativeAverageDurationRaw {
  [IWorkingDaysAnalyticsActivityEnum.TotalDuration]: string;
  [IWorkingDaysAnalyticsActivityEnum.count]: string;
  [IWorkingDaysAnalyticsActivityEnum.DayCount]: string;
  [IWorkingDaysAnalyticsActivityEnum.WeekCount]: string;
  [IWorkingDaysAnalyticsActivityEnum.AppId]: string;
}

export interface CumulativeAverageDurationV2Raw {
  [IWorkingDaysAnalyticsActivityV2Enum.TotalDuration]: string;
  [IWorkingDaysAnalyticsActivityV2Enum.count]: string;
  [IWorkingDaysAnalyticsActivityV2Enum.TotalCallDuration]: string;
  [IWorkingDaysAnalyticsActivityV2Enum.CallCount]: string;
  [IWorkingDaysAnalyticsActivityV2Enum.DayCount]: string;
  [IWorkingDaysAnalyticsActivityV2Enum.WeekCount]: string;
  [IWorkingDaysAnalyticsActivityV2Enum.AppId]: string;
}
